module.exports = __webpack_public_path__ + "img/COM-A-1-I.1f269adc.png";